import { Component } from '@angular/core';
import { StatusBarItem, StatusBarService } from '@services/status-bar/status-bar.service';

@Component({
  selector: '[status-bar]',
  templateUrl: 'status-bar.component.html'
})
export class StatusBarComponent {
  get items(): StatusBarItem[] {
    return this.statusBarService.getItems();
  }

  constructor(private statusBarService: StatusBarService) {}

  itemClicked(event: Event, item: StatusBarItem) {
    if (item.handler) {
      item.handler(event);
    }
  }
}
